import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const usePreDevis = () => {
  const [mode, setMode] = useState("sur_place");
  const [distance, setDistance] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const generate = async (request) => {
    setLoading(true);
    try {
      const distance_km = mode === "domicile" ? Number(distance) || 0 : 0;
      const { data } = await axios.post(
        `${API}/requests/${request.id}/pre-devis`,
        { mode, distance_km },
        { withCredentials: true },
      );
      setResult(data);
    } catch (err) {
      const msg = err.response?.data?.detail || "Génération impossible. Réessaie dans un instant.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const copyDraft = async () => {
    if (!result?.brouillon_client) return;
    try {
      await navigator.clipboard.writeText(result.brouillon_client);
      toast.success("Brouillon copié");
    } catch {
      toast.error("Copie impossible");
    }
  };

  return { mode, setMode, distance, setDistance, loading, result, generate, copyDraft };
};
